import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Zhibo = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M14.546 14H7a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h34a3 3 0 0 0 3-3V17a3 3 0 0 0-3-3h-7.546l5.04-5.671-2.989-2.658L28.102 14h-8.204l-7.403-8.329-2.99 2.658L14.546 14ZM8 18v20h32V18H8Zm14.5 8.066v4.522l3.392-2.45-3.392-2.072Zm-4-1.783c0-2.343 2.565-3.781 4.564-2.56l6.196 3.787c1.83 1.117 1.93 3.737.192 4.991l-6.196 4.475c-1.983 1.433-4.756.016-4.756-2.432v-8.26Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
